import { useMutation } from "@tanstack/react-query";
import { FormattedTagType } from "../../../modules/tagsAndMetadataTags/pages/TagsAndMetadataTags/Tabs/Content/Tags/components/TagDetails/context/types";
import { createTagType } from "../api/createTagType";
import { CreateServicePrimaryTag } from "../types";
import { invalidateServicePrimaryTagListQuery } from "./useServicePrimaryTagListQuery";

type Params = {
  tagType: CreateServicePrimaryTag;
  handleTagType: (value: FormattedTagType) => void;
};

export const useCreateTagTypeQuery = () => {
  return useMutation({
    mutationFn: async ({ tagType, handleTagType }: Params) => {
      const response = await createTagType(tagType);
      return handleTagType({
        id: response.id,
        name: response.name,
      });
    },
    onSuccess: (_) => {
      invalidateServicePrimaryTagListQuery();
    },
    onError: (e) => console.error(e),
  });
};
